declare module '@zondax/ledger-filecoin'
